import { Component } from '@angular/core';
import { AppMainComponent } from '../main/app.main.component';
import { MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';
import { TokenService } from '../../../auth/services/token/token.service';
import { LogoutService } from './logout.service';
import { UserActiveService } from 'src/app/pages/gestion/users/active/user-active.service';
import { IUserActiveBase } from 'src/app/pages/gestion/users/active/user-active.interface';
import { PagesMenuSellerEssential } from 'src/app/pages/pages-menu-seller-essential';
import { PagesMenuAdminEssential } from 'src/app/pages/pages-menu-admin-essential';
import { PagesMenuAdminAdvanced } from 'src/app/pages/pages-menu-admin-advanced';

@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  providers: [MessageService]
})
export class AppTopBarComponent {
  items: MenuItem[];
  fullName = '';

  constructor(
    public appMain: AppMainComponent,
    private messageService: MessageService,
    private tokenService: TokenService,
    private logoutService: LogoutService,
    private userActiveService: UserActiveService
  ) {}

  ngOnInit() {
    if (this.tokenService.isSeller()) {
      this.items = PagesMenuSellerEssential;
    } else {
      if (this.tokenService.isAdvanced()) {
        this.items = PagesMenuAdminAdvanced;
      } else {
        this.items = PagesMenuAdminEssential;
      }
    }
    this.userActiveService.getData$().subscribe((data: IUserActiveBase[]) => {
      if (data) {
        this.fullName = data[0].names + ' ' + data[0].surnames;
      }
    });
  }

  exit() {
    localStorage.clear();
    location.reload();
  }
  showConfirm() {
    this.messageService.clear();
    this.messageService.add({
      key: 'c',
      sticky: true,
      severity: 'warn',
      summary: '¿Estás seguro?',
      detail: 'Confirmación para proceder'
    });
  }
  async onConfirm() {
    await this.logoutService.logout();
    this.messageService.clear('c');
    this.exit();
  }

  onReject() {
    this.messageService.clear('c');
  }

  clear() {
    this.messageService.clear();
  }
}
